import store, { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';

/**
 * Pagination info and arrows.
 */
export const PaginationControlArtists = () => {

    const dispatch = useAppDispatch();
    const currentPage = useAppSelector(store => store.currentPage);
    const pagination = useAppSelector(store => store.pagination);

    /**
     * Apply pagination.
     */
    const applyPagination = (isPrev: boolean) => {

        sendGAEvent('JPList', isPrev ? 'Bottom Previous' : 'Bottom Next');

        const updatedState = {...store.getState()};

        if(isPrev && updatedState.currentPage > 0) {
            updatedState.currentPage--;
        }

        if(!isPrev && updatedState.pagination && updatedState.currentPage < updatedState.pagination.pagesNumber - 1) {
            updatedState.currentPage++;
        }

        dispatch(rootActions.refresh(updatedState));

        // jump to top
        window.scrollTo(0, 0);
    };

    return (
        <div className="flex items-center">
            <button
                type="button"
                className="cursor-pointer mr-1"
                onClick={evt => {
                    applyPagination(true);
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><title>Previous Page Button</title><g fill="none" fillRule="evenodd"><rect width="29" height="29" x=".5" y=".5" fill="#D8D8D8" fillRule="nonzero" stroke="#979797" opacity=".123" rx="14.5"/><path d="M17.295 9.705c.39.39.39 1.02 0 1.41L13.42 15l3.876 3.884a.999.999 0 0 1-1.411 1.411L10.59 15l5.295-5.295a.996.996 0 0 1 1.41 0z" fill="#252525"/></g></svg>
            </button>

            <button
                type="button"
                className="cursor-pointer ml-1"
                onClick={evt => {
                    applyPagination(false);
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><title>Next Page Button</title><g fill="none" fillRule="evenodd"><rect width="29" height="29" x=".5" y=".5" fill="#D8D8D8" fillRule="nonzero" stroke="#979797" opacity=".123" rx="14.5"/><path d="M12.705 9.705a.996.996 0 0 0 0 1.41L16.58 15l-3.876 3.884a.999.999 0 0 0 1.411 1.411L19.41 15l-5.295-5.295a.996.996 0 0 0-1.41 0z" fill="#252525"/></g></svg>
            </button>

            <span className="mx-4">
                Page { currentPage + 1} of { pagination ? pagination.pagesNumber : ''}
            </span>
        </div>
    )
};